// extracted by mini-css-extract-plugin
module.exports = {"containerContact":"styles_containerContact__2g0iC","containerContactGlobal":"styles_containerContactGlobal__3nQUu","contactMedia":"styles_contactMedia__1VZjj"};